import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import { PartImage } from '../../../types/part/partTypes'
import anchor from '../../../constants/anchor'

const reorderPartImages = (partId: string, images: PartImage[]) => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    const params = {
        userId: userData.smsAuth.userId,
        partId,
        images
    }
    try {

        const { data: { status } } = await apiInstance.post('/setPartReorderImages', params , config)
        if(status === 'ok') {
            dispatch(({
                type: storeDispatchTypes.reorderPartImages,
                value: {
                    id: partId,
                    images
                },
            }))
        }

    } catch (e) {
        console.error('reorder part images failed', e)
    }
}

export default reorderPartImages
